import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useLoginModal } from "./contexts/LoginModalContext";
import Loader from "./components/loader";
import AuthenticationWorkflow from "./authentication-workflow/authenticationWorkflow";
import Incoming from "./pages/incoming";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import DoctorsList from "./pages/DoctorsList";
import MainLandingPage from "./pages/LandingPage";
import VideoCall from "./pages/video-call";
import AppointmentVideoCall from "./pages/appointment-video-call";
import DoctorProfile from "./pages/DoctorProfile";
import SpecialistDoctorProfile from "./pages/SpecialistDoctorProfile";
import PackagePage from "./pages/PackagePage";
import PaymentMethod from "./pages/PaymentMethod";
import PrescriptionsList from "./pages/prescriptions-list";
import Prescription from "./pages/prescription";
import AppointmentCard from "./components/AppointmentCard";
import Appointment from "./pages/Appointment";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import SelectAppointment from "./pages/SelectAppointment";
import BookedAppointment from "./pages/BookedAppointment";
import PreviousAppointments from "./pages/PreviousAppointments";
import AppointmentPaymentCancel from "./pages/AppointmentPaymentCancel";
import AppointmentPaymentSuccess from "./pages/AppointmentPaymentSuccess";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ResetPasswordWithPhone from "./pages/ResetPasswordWithPhone";
import DebitSuccessFail from "./pages/DebitSuccessFail";
import LoginLanding from "./components/LoginLanding";
import FeedbackPage from "./pages/FeedbackPage";
import Profile from "./pages/Profile";
import ComingSoon from "./pages/ComingSoon";
import Wallet from "./pages/Wallet";
import OurPackages from "./pages/OurPackages";
function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { showLoginModal, setShowLoginModal } = useLoginModal();

  // Modal close on background click
  const handleModalBackgroundClick = (e) => {
    if (e.target.className === "login-modal-overlay") {
      setShowLoginModal(false);
    }
  };

  return (
    <>
      {/* Global Login Modal */}
      {showLoginModal && (
        <div
          className="modal border fade show d-block border login-modal-overlay"
          tabIndex="-1"
          role="dialog"
          style={{ background: "rgba(0,0,0,0.35)" }}
          onClick={handleModalBackgroundClick}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-md"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content p-0 bg-transparent">
              <a
                className="btn-close position-absolute end-0 me-1 mt-2"
                aria-label="Close"
                style={{ zIndex: 2, cursor: "pointer" }}
                onClick={() => setShowLoginModal(false)}
              ></a>
              <LoginLanding />
            </div>
          </div>
        </div>
      )}
      <Routes>
        <Route path="/" element={<MainLandingPage />} />
        <Route path="/home" element={<MainLandingPage />} />
        <Route path="/login/:route" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/profile" element={<Profile />} />
        <Route
          path="/reset-password-phone"
          element={<ResetPasswordWithPhone />}
        />
        <Route path="/packages" element={<PackagePage />} />
        <Route path="/ourPackages" element={<OurPackages />} />
        <Route path="/payment-method" element={<PaymentMethod />} />
        <Route path="/doctors-list" element={<DoctorsList />} />
        <Route path="/doctor-profile/:id" element={<DoctorProfile />} />
        <Route
          path="/special-doctor-profile/:id"
          element={<SpecialistDoctorProfile />}
        />
        <Route path="/video-call" element={<VideoCall />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route
          path="/appointment-video-call"
          element={<AppointmentVideoCall />}
        />
        <Route path="/prescriptions" element={<PrescriptionsList />} />
        <Route path="/prescription/:id" element={<Prescription />} />
        <Route path="/incoming" element={<Incoming />} />
        <Route path="/appointment" element={<Appointment />} />
        {/* <Route path="/appointment" element={<ComingSoon />} /> */}
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/debit-payment-status" element={<DebitSuccessFail />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        <Route
          path="/appointment-payment-cancel"
          element={<AppointmentPaymentCancel />}
        />
        <Route
          path="/appointment-payment-success"
          element={<AppointmentPaymentSuccess />}
        />
        <Route path="/selectappointment/:id" element={<SelectAppointment />} />
        <Route path="/bookedappointment" element={<BookedAppointment />} />
        <Route
          path="/previousappointments"
          element={<PreviousAppointments />}
        />
        <Route path="/wallet" element={<Wallet />} />
      </Routes>
    </>
  );
}

export default App;
